export default {
    setMessages(state, payload) {
        state.messages = payload.response
        state.loading = payload.response === null;
    },
   
}
